module.exports = __webpack_public_path__ + "img/trash_outlined_32.da49f5f3.svg";